import { Entitlement } from '@dxb-web-ui-framework/iam/domain/AccessControl/entities';
import { EntitlementsData, EntitlementsDataResponseDTO } from '../entities/EntitlementsDataResponseDTO';

const entitlementsDataResponseDTOtoEntitlementsDataAdapter = (
  response: EntitlementsDataResponseDTO,
): EntitlementsData => {
  if (!response.body) {
    throw Error();
  }
  const appTransactions = response.body.appTransactions.map(
    entitlement => new Entitlement(entitlement.id, entitlement.name, entitlement.description),
  );

  return {
    appTransactions,
    prospect: response.body.prospect,
    onboardingRedirectURL: response.body.onboardingRedirectURL,
  };
};

export { entitlementsDataResponseDTOtoEntitlementsDataAdapter };
